// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import rskEntity from './entities/rsk.json';
import rskMenu from '../pages/rsk/menu.json';
import rskFullForm from '../pages/rsk/forms/full.json';
import rskContextForm from '../pages/rsk/forms/context.json';
import rskMiniForm from '../pages/rsk/forms/mini.json';
import rskLookupForm from '../pages/rsk/forms/lookup.json';
import rskTableView from '../pages/rsk/views/table.json';
import rskStagesView from '../pages/rsk/views/stages.json';
import rskCardsView from '../pages/rsk/views/cards.json';
import rskInlineView from '../pages/rsk/views/inline.json';
import rskBacklogView from '../pages/rsk/views/backlog.json';
import rskSplitView from '../pages/rsk/views/split.json';
import rskCalendarView from '../pages/rsk/views/calendar.json';
import rskDashboardView from '../pages/rsk/views/dashboard.json';
import rskRiskmatrixView from '../pages/rsk/views/riskmatrix.json';

/** Тип запису «Ризик» зі сторінками пакета: меню, форми та подання з pages/rsk/. */
export const rskDefinition: IRecordTypeDefinition = {
  ...rskEntity,
  views: assembleViewSet({
      table: rskTableView,
      stages: rskStagesView,
      cards: rskCardsView,
      inline: rskInlineView,
      backlog: rskBacklogView,
      split: rskSplitView,
      calendar: rskCalendarView,
      dashboard: rskDashboardView,
      riskmatrix: rskRiskmatrixView,
  }),
  form: rskFullForm,
  forms: { full: rskFullForm, context: rskContextForm, mini: rskMiniForm, lookup: rskLookupForm },
  menu: rskMenu,
} as IRecordTypeDefinition;
